module.exports = __webpack_public_path__ + "img/CS2_section_1_spin_circle_1.62ea283a.png";